import { render, staticRenderFns } from "./LandingPageOres.vue?vue&type=template&id=cae25408&scoped=true"
import script from "./LandingPageOres.vue?vue&type=script&lang=ts"
export * from "./LandingPageOres.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae25408",
  null
  
)

export default component.exports